import { useEffect, useState } from 'react';
import { billingAPI } from '../api/billing';

export interface PlanGate {
  loading: boolean;
  needsPlan: boolean;
  plan: string | null;
}

/**
 * Resolves whether a signed-in user still needs to pick a plan.
 * Owner (unlimited) and paid plans pass; a `free`/no plan is gated to pricing.
 */
export function usePlanGate(isSignedIn: boolean): PlanGate {
  const [state, setState] = useState<PlanGate>({
    loading: true,
    needsPlan: false,
    plan: null,
  });

  useEffect(() => {
    let cancelled = false;
    if (!isSignedIn) {
      setState({ loading: false, needsPlan: false, plan: null });
      return;
    }
    setState((s) => ({ ...s, loading: true }));
    billingAPI
      .getMyPlan()
      .then((r) => {
        if (cancelled) return;
        setState({
          loading: false,
          plan: r.plan,
          needsPlan: !r.unlimited && r.plan === 'free',
        });
      })
      .catch(() => {
        // Fail open: an unavailable plan lookup should not lock a user out.
        if (!cancelled) setState({ loading: false, needsPlan: false, plan: null });
      });
    return () => {
      cancelled = true;
    };
  }, [isSignedIn]);

  return state;
}
